const ThreeDotsIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    viewBox="0 0 8 28"
    fill="currentColor"
    className={className}
    aria-hidden="true"
  >
    <circle cx="4" cy="4" r="3.5" />
    <circle cx="4" cy="14" r="3.5" />
    <circle cx="4" cy="24" r="3.5" />
  </svg>
);

export default ThreeDotsIcon;
